import { render } from "./AcceptableUsePolicy.vue?vue&type=template&id=3fd1a1e8"
import script from "./AcceptableUsePolicy.vue?vue&type=script&lang=js"
export * from "./AcceptableUsePolicy.vue?vue&type=script&lang=js"
script.render = render

export default script